import { ErrorMessageDetails } from '@mtna/core-angular';
import { createAction, props } from '@ngrx/store';
import { RdsDataProduct, SupportedOperations } from '@rds/rds-metadata-ts';

export const loadDataProductSuccess = createAction(
  '[Data Product/API] Load Data Product Success',
  props<{ dataProduct: RdsDataProduct }>()
);
export const loadDataProductFailure = createAction('[Data Product/API] Load Data Product Failure', props<{ error: ErrorMessageDetails }>());

export const loadSupportedOperationsSuccess = createAction(
  '[Data Product/API] Load Supported Operations Success',
  props<{ operations: SupportedOperations }>()
);
export const loadSupportedOperationsFailure = createAction(
  '[Data Product/API] Load Supported Operations Failure',
  props<{ error: ErrorMessageDetails }>()
);

export const loadVariableCountSuccess = createAction(
  '[Data Product/API] Load Variable Count Success',
  props<{ numberOfVariables: number }>()
);
export const loadVariableCountFailure = createAction(
  '[Data Product/API] Load Variable Count Failure',
  props<{ error: ErrorMessageDetails }>()
);
